import { useParams } from "react-router-dom"
import ExamScore from "./exam_Score"


const ExamScoreCover = () =>{
    const {id , course_name, courseid} = useParams()
    return(
        <>
            <ExamScore id={id}  courseid={courseid} course_name={course_name}/>
        </>
    )
}

export default ExamScoreCover